import { FormContainerStepProps } from 'components';
import { useTranslation } from 'libs/i18n';
import { FileType, FileUpload, Stack } from 'libs/ui';
import {
  ClientType,
  FormBodyWrapper,
} from 'modules/onboarding/common/components';

import {
  CompanyStateRegistrationFormType,
  FormErrors,
  Field,
  getSchema,
  MAX_FILES,
} from '../../forms/companyStateRegistrationForm';

import { FormContent } from './FormContent';

interface Props extends FormContainerStepProps {
  initialValues?: CompanyStateRegistrationFormType;
  onSubmit: (values: CompanyStateRegistrationFormType) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  formError?: FormErrors;
  submitLoading?: boolean;
  submitDisabled?: boolean;
  enabledFiles?: boolean;
  enabledLastStateReRegistrationDate?: boolean;
  files?: FileUpload[];
  clientType?: ClientType;
  subTitle?: string;
  onAddFiles?: (file: File[]) => void;
  onRemoveFile?: (file: FileUpload, index: number) => void;
}

export const CompanyStateRegistration = ({
  initialValues,
  canGoBack,
  submitLoading,
  submitDisabled,
  formError,
  files,
  step,
  clientType,
  subTitle,
  enabledFiles = true,
  enabledLastStateReRegistrationDate,
  onGoBack,
  onAddFiles,
  onRemoveFile,
  onSubmit,
}: Props) => {
  const { t } = useTranslation();
  const schema = getSchema(t, enabledFiles);
  return (
    <FormBodyWrapper
      canGoBack={canGoBack}
      clientType={clientType}
      initialErrors={formError}
      initialValues={initialValues}
      step={step}
      submitDisabled={submitDisabled}
      submitLoading={submitLoading}
      subTitle={subTitle ?? t('onboarding.companyStateRegistration.subtitle')}
      title={t('onboarding.companyStateRegistration.title')}
      validationSchema={schema}
      onGoBack={onGoBack}
      onSubmit={onSubmit}
    >
      <Stack spacing={32}>
        <FormContent
          enabledLastStateReRegistrationDate={
            enabledLastStateReRegistrationDate
          }
        />
        {enabledFiles && (
          <Field.FilesUpload
            files={files}
            fileTypes={[FileType.pdf]}
            maxFiles={MAX_FILES}
            name="fileIds"
            title={t('onboarding.companyStateRegistration.documentTitle')}
            onAddFiles={onAddFiles}
            onRemoveFile={onRemoveFile}
          />
        )}
      </Stack>
    </FormBodyWrapper>
  );
};
